module.exports = __webpack_public_path__ + "static/media/tiff.067def7e.png";